import createDOMPurify from 'dompurify';

// js.erb が渡すメッセージは <br> やリンクを含む HTML。描画直前にここを通し、それ以外のタグ・属性・
// javascript: 等の URI を落とす。描画後に文字列を加工してはならない
const purifier = createDOMPurify();

purifier.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export function sanitizeToastHtml(html: string): string {
  return purifier.sanitize(html, {
    ALLOWED_TAGS: ['br', 'a'],
    ALLOWED_ATTR: ['href', 'target'],
    ALLOW_DATA_ATTR: false,
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|[./#?][^:]*|[^:]*$)/i,
  });
}
